__turbopack_context__.v({
  "img": "ListSection-module-scss-module__w7dh3G__img",
  "root": "ListSection-module-scss-module__w7dh3G__root",
  "textWrap": "ListSection-module-scss-module__w7dh3G__textWrap",
});
